import type React from 'react';

import { Helmet } from 'react-helmet-async';

import { useI18n } from '@change-corgi/core/react/i18n';

export const Title: React.FC = () => {
	const { translate } = useI18n();

	return (
		<Helmet>
			<title>{translate('corgi.sap.meta_tags.title')}</title>
		</Helmet>
	);
};
